import * as B from '@blueprintjs/core';
import React from 'react';
import {TableInstance} from 'react-table';

import ActiveFiltersCountButton from 'app/components/ActiveFiltersCountButton/ActiveFiltersCountButton';
import {ApiShareLink} from 'app/modules/Remote/ShareLink';

import {SearchBoxFilter} from '../ColumnFilters';
import {TableSortMenu} from '../PropertyTable';
import {countActiveFilters} from '../tableUrlState';
import {
  CREATED_COLUMN_ID,
  PROPERTY_COLUMN_ID,
  SORTABLE_COLUMN_IDS,
  TYPE_COLUMN_ID,
  shareLinkTypes,
} from './shareLinksTableState';
import cs from './styles.module.scss';

const PortfolioShareLinksControls: React.FunctionComponent<{
  table: TableInstance<ApiShareLink>;
  shareLinks: ApiShareLink[];
}> = ({table, shareLinks}) => {
  const columnById = (id: string) => table.columns.find((col) => col.id === id)!;
  const propertyColumn = columnById(PROPERTY_COLUMN_ID);
  const typeColumn = columnById(TYPE_COLUMN_ID);
  const createdColumn = columnById(CREATED_COLUMN_ID);

  const sortableColumns = table.columns.filter((col) => SORTABLE_COLUMN_IDS.includes(col.id));
  const sortColumn = sortableColumns.find((col) => col.isSorted) ?? createdColumn;

  const activeFilterCount = countActiveFilters(table.state.filters);
  const types = React.useMemo(() => shareLinkTypes(shareLinks), [shareLinks]);

  const filterPanel = (
    <div className={cs.filterPanel}>
      <B.FormGroup label="Type">
        <B.HTMLSelect
          fill
          value={typeColumn.filterValue ?? ''}
          onChange={(ev) => table.setFilter(TYPE_COLUMN_ID, ev.currentTarget.value || undefined)}
          options={[
            {label: 'All types', value: ''},
            ...types.map((type) => ({label: type, value: type})),
          ]}
        />
      </B.FormGroup>
    </div>
  );

  return (
    <div className={cs.controls}>
      <B.ButtonGroup>
        <B.Popover content={filterPanel} position={B.Position.BOTTOM_LEFT}>
          <ActiveFiltersCountButton count={activeFilterCount} outlined />
        </B.Popover>
        {activeFilterCount > 0 && (
          <B.Tooltip content="Clear all filters">
            <B.Button icon="filter-remove" outlined onClick={() => table.setAllFilters([])} />
          </B.Tooltip>
        )}
      </B.ButtonGroup>
      <TableSortMenu columns={sortableColumns} sortColumn={sortColumn} />
      <SearchBoxFilter
        setFilter={table.setFilter}
        column={propertyColumn}
        placeholder="Search share links…"
      />
    </div>
  );
};

export default PortfolioShareLinksControls;
